import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from './api-base';

@Injectable({
  providedIn: 'root'
})
export class OrgStructureService {
  private apiUrl = `${API_BASE_URL}/org-structure`;

  constructor(private http: HttpClient) {}

  getSectors(tenantId: number): Observable<any[]> {
    const params = new HttpParams().set('tenant_id', tenantId);
    return this.http.get<any[]>(`${this.apiUrl}/sectors`, { params });
  }

  createSector(payload: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/sectors`, payload);
  }

  updateSector(sectorId: number, payload: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/sectors/${sectorId}`, payload);
  }

  getDepartments(
    tenantId: number,
    sectorId?: number | null,
    controlhelpOnly?: boolean,
    controlhelpPurpose?: 'ORIGIN' | 'DESTINATION'
  ): Observable<any[]> {
    let params = new HttpParams().set('tenant_id', tenantId);
    if (sectorId) {
      params = params.set('sector_id', sectorId);
    }
    if (controlhelpOnly) {
      params = params.set('controlhelp_only', '1');
    }
    if (controlhelpPurpose) {
      params = params.set('controlhelp_purpose', controlhelpPurpose);
    }
    return this.http.get<any[]>(`${this.apiUrl}/departments`, { params });
  }

  createDepartment(payload: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/departments`, payload);
  }

  getLocations(tenantId: number, departmentId?: number | null): Observable<any[]> {
    let params = new HttpParams().set('tenant_id', tenantId);
    if (departmentId) {
      params = params.set('department_id', departmentId);
    }
    return this.http.get<any[]>(`${this.apiUrl}/locations`, { params });
  }

  createLocation(payload: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/locations`, payload);
  }
}
